import { AppError } from "../../../shared/utils/error-handler";
import type { AdminMachineProductRepository } from "../../repositories/admin/admin-machine-product-repository";
import type {
  MachineProductEntity,
  CreateMachineProductRequest,
  UpdateMachineProductRequest,
} from "../../types/machine-product";
import type { UnreportedMachineProductEntity } from "../../types/unreported-machine-product";

export class AdminMachineProductUseCase {
  constructor(
    private adminMachineProductRepository: AdminMachineProductRepository
  ) {}

  async getAll(): Promise<MachineProductEntity[]> {
    try {
      return await this.adminMachineProductRepository.getAll();
    } catch (error) {
      throw new AppError(
        String(error) || "장비 제품 목록을 불러오지 못했습니다.",
        "MACHINE_PRODUCT_LIST_FAILED",
        error
      );
    }
  }

  async getById(id: number): Promise<MachineProductEntity> {
    try {
      return await this.adminMachineProductRepository.getById(id);
    } catch (error) {
      throw new AppError(
        String(error) || "장비 제품 상세를 불러오지 못했습니다.",
        "MACHINE_PRODUCT_DETAIL_FAILED",
        error
      );
    }
  }

  async create(
    request: CreateMachineProductRequest
  ): Promise<MachineProductEntity> {
    try {
      return await this.adminMachineProductRepository.create(request);
    } catch (error) {
      throw new AppError(
        String(error) || "장비 제품 생성에 실패했습니다.",
        "MACHINE_PRODUCT_CREATE_FAILED",
        error
      );
    }
  }

  async update(
    id: number,
    request: UpdateMachineProductRequest
  ): Promise<MachineProductEntity> {
    try {
      return await this.adminMachineProductRepository.update(id, request);
    } catch (error) {
      throw new AppError(
        String(error) || "장비 제품 수정에 실패했습니다.",
        "MACHINE_PRODUCT_UPDATE_FAILED",
        error
      );
    }
  }

  async delete(id: number): Promise<boolean> {
    try {
      return await this.adminMachineProductRepository.delete(id);
    } catch (error) {
      throw new AppError(
        String(error) || "장비 제품 삭제에 실패했습니다.",
        "MACHINE_PRODUCT_DELETE_FAILED",
        error
      );
    }
  }

  async getAllUnreported(): Promise<UnreportedMachineProductEntity[]> {
    try {
      return await this.adminMachineProductRepository.getAllUnreported();
    } catch (error) {
      throw new AppError(
        String(error) || "미보고 장비 목록을 불러오지 못했습니다.",
        "UNREPORTED_MACHINE_PRODUCT_LIST_FAILED",
        error
      );
    }
  }

  async deleteUnreported(id: number): Promise<boolean> {
    try {
      return await this.adminMachineProductRepository.deleteUnreported(id);
    } catch (error) {
      throw new AppError(
        String(error) || "미보고 장비 삭제에 실패했습니다.",
        "UNREPORTED_MACHINE_PRODUCT_DELETE_FAILED",
        error
      );
    }
  }

  async getUnreportedById(
    id: number
  ): Promise<UnreportedMachineProductEntity> {
    try {
      return await this.adminMachineProductRepository.getUnreportedById(id);
    } catch (error) {
      throw new AppError(
        String(error) || "미보고 장비 상세를 불러오지 못했습니다.",
        "UNREPORTED_MACHINE_PRODUCT_DETAIL_FAILED",
        error
      );
    }
  }
}